import { NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';

import { CommonModule } from '@angular/common';
import { InstorelistComponent } from './instorelist/instorelist.component';
import { ModifyinstoreComponent } from './modifyinstore/modifyinstore.component';

import { NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';

import {​​​​​​​​ MatDatepickerModule }​​​​​​​​ from'@angular/material/datepicker';
import {​​​​​​​​ MatInputModule }​​​​​​​​ from'@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSortModule} from '@angular/material/sort';   
import { ConfirmDialogModule } from '@app/module/confirm-dialog/confirm-dialog.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/*import { BulkInstoreSearch } from '@app/_services/bulkinstoresearch.pipe';*/

@NgModule({
  declarations: [InstorelistComponent, ModifyinstoreComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPaginationModule,MatSortModule,
    NgbAlertModule,MatDatepickerModule,MatInputModule,MatNativeDateModule,NgbModule,ToastrModule,ConfirmDialogModule,
    Ng2SearchPipeModule,NgMultiSelectDropDownModule.forRoot()
    
  ]
})
export class InstorelistModule { }
